import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { mainnet, bsc } from '@reown/appkit/networks';
import { http } from 'viem';
import type { AppKitNetwork } from '@reown/appkit/networks';

// ✅ Use environment variable for project ID
export const projectId = import.meta.env.VITE_PROJECT_ID!;
if (!projectId) {
  throw new Error('Project ID is not defined');
}

// ✅ FIXED: Added https:// to the URL
export const metadata = {
  name: 'Quantum Genesis',
  description: 'Revolutionary quantum-powered meme coin with innovative tokenomics, staking rewards, and a secure, audited smart contract.',
  url: 'https://quantumgenesis.io',
  icons: ['https://quantumgenesis.io/favicon.svg'],
};

// ✅ Network configuration
export const networks = [mainnet, bsc] as [AppKitNetwork, ...AppKitNetwork[]];

// ✅ FIXED: Add `metadata` to WagmiAdapter
export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
  defaultChainId: mainnet.id,
  transport: http(),
  metadata, // ✅ critical for MetaMask branding
  mode: 'dark',
  testMode: true
});

// ✅ Contract constants
export const contractAddress = '0x33A219Ec2F9afa19D77E9abE2303253fB5072D91' as const;
export const usdtAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7' as const;
export const defaultReferral = '0x0000000000000000000000000000000000000000' as const;

// ✅ Re-export referrals
export * from './referrals';
